import { createPortal } from 'react-dom';

import { useViewportSlots } from '@/hooks/use-viewport-slots';
import { is3DViewport } from '@/visualization/viewports/viewport-categories';
import { CarmEditPanel } from '@/workflows/vascular/common/components/carm/carm-edit-panel';
import { useCarmEdit } from '@/workflows/vascular/common/hooks/use-carm-edit';

/**
 * Bridge component that portals the C-arm edit panel into the 'carm' slot of
 * the 3D viewport cell. Renders nothing outside C-arm edit mode — the panel
 * mounts on carm:edit:started and unmounts on commit/cancel.
 *
 * Place as a sibling of ViewportContainer within the VisualizationProvider tree.
 */
export function CarmEditPanelManager() {
    const viewports = useViewportSlots(['carm']);
    const edit = useCarmEdit();

    if (!edit) return null;

    return (
        <>
            {viewports
                .filter((vp) => vp.slotKind === 'viewport' && vp.type && is3DViewport(vp.type))
                .map((vp) => {
                    const slot = vp.slots['carm'];
                    if (!slot) return null;
                    return createPortal(<CarmEditPanel edit={edit} />, slot, `carm-edit-panel-${vp.id}`);
                })}
        </>
    );
}
